import { Env, getEnv, getRegion, Region } from '@adsk/acs-sc-web-platform-api';

import { ENV_CONFIGS, SCHEDULE_ENV_CONFIG_KEYS } from './consts';

const getEnvConfig = (env: Env, region: Region, key: string) => {
  if (ENV_CONFIGS?.[region]?.[env]?.[key]) {
    return ENV_CONFIGS[region][env][key];
  } else {
    throw new Error(
      `Cannot find env config for env: ${env}, region: ${region} and key: ${key}`,
    );
  }
};

/**
 * Get the base URL for the schedule service.
 */
export const getBaseScheduleUrl = (
  envConfig: keyof typeof SCHEDULE_ENV_CONFIG_KEYS,
) => {
  const env = getEnv();
  const region = getRegion();

  return getEnvConfig(env, region, envConfig);
};
